module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp2_3.0b28fa76.png";